// extracted by mini-css-extract-plugin
export var container = "_3f-0";
export var error = "_3f-9";
export var label = "_3f-5";
export var light = "_3f-6";
export var md = "_3f-3";
export var sm = "_3f-2";
export var thin = "_3f-8";
export var thinBold = "_3f-7";
export var vertical = "_3f-4";
export var xs = "_3f-1";